import React from 'react';
import Form from 'react-bootstrap/Form';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import RichText from '../controls/RichText';
import { useForceUpdate } from '../util';
import { Content } from '../DataStructures';
import { contentIsEmpty } from './TaskMultiChoice';
import { FormValidityReporter } from '../FormValidity';
export default function TaskLikertScale(props) {
  const forceUpdate = useForceUpdate();
  const dataProps = props.data.props;
  return /*#__PURE__*/React.createElement(Form, null, /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Form.Label, null, /*#__PURE__*/React.createElement("b", null, "Prompt:")), /*#__PURE__*/React.createElement(RichText, {
    value: dataProps.prompt,
    inlineOnly: true,
    onChange: v => {
      dataProps.prompt = v;
      forceUpdate();
      props.onChanged();
    }
  }), /*#__PURE__*/React.createElement(FormValidityReporter, {
    valid: !contentIsEmpty(dataProps.prompt)
  }, "Prompt is empty")), /*#__PURE__*/React.createElement(Form.Label, null, /*#__PURE__*/React.createElement("b", null, "Labels:")), dataProps.labels.map((label, key) => {
    return /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Form.Row, {
      className: "align-items-center mb-2"
    }, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(RichText, {
      value: label,
      inlineOnly: true,
      onChange: v => {
        dataProps.labels[key] = v;
        forceUpdate();
        props.onChanged();
      }
    }), /*#__PURE__*/React.createElement(FormValidityReporter, {
      valid: !contentIsEmpty(dataProps.labels[key])
    }, "Label cannot be empty")), /*#__PURE__*/React.createElement(Col, {
      xs: "auto"
    }, dataProps.labels.length > 3 && /*#__PURE__*/React.createElement(Button, {
      variant: "outline-danger",
      title: "Remove choice",
      onClick: () => {
        dataProps.labels.splice(key, 1);
        dataProps.intervals--;
        props.triggerStateUpdate();
        props.onChanged();
      }
    }, /*#__PURE__*/React.createElement("i", {
      className: "bi bi-trash"
    })))));
  }), (dataProps.labels.length < 8 ? true : false) && /*#__PURE__*/React.createElement(Button, {
    variant: "success",
    title: "Add new choice",
    onClick: () => {
      dataProps.labels.push(new Content());
      dataProps.intervals++;
      props.triggerStateUpdate();
      props.onChanged();
    }
  }, /*#__PURE__*/React.createElement("i", {
    className: "bi bi-plus-lg"
  })));
}